import React, {useEffect, useState} from 'react';
import {useInvitationRewardStore} from './invitation-reward.store';
import {useShare} from '@/common-pages/hooks/share.hooks';
import InvitationBigProgress from './components/invitation-big-progress';
import StatsCards from './components/stats-cards';
import InvitationRewardCard from './components/invitation-reward-card';
import RewardRulesModal from './components/reward-rules-modal';
import {goTo} from '@/utils';
import {useLogin} from '@/utils/state-hooks';
import {ProgressiveCircularLoading} from '@fe-progressive/package-progressive/progressive-loading';

const InvitationRewardContent = () => {
  const {userList, rewardRules, loading, loadData, userTotal} =
    useInvitationRewardStore();
  const {doShare, initShare, code} = useShare();
  const [showRulesModal, setShowRulesModal] = useState(false);
  const login = useLogin();
  useEffect(() => {
    // 未登录时也能访问，但不初始化分享
    initShare();

    // 加载数据（store 内部会处理未登录情况）
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [login]);

  const handleShare = () => {
    // 如果未登录，跳转到登录页
    if (!login) {
      goTo('Login');
      return;
    }

    // 已登录则正常分享
    doShare();
  };

  const handleQuestionClick = () => {
    setShowRulesModal(true);
  };

  const handleCloseModal = () => {
    setShowRulesModal(false);
  };

  if (loading) {
    return (
      <div className="flex-1 p-4 flex items-center justify-center">
        <ProgressiveCircularLoading />
      </div>
    );
  }

  return (
    <div className="flex-1 p-3 flex flex-col gap-3 overflow-y-auto">
      {/* 第一块：统计卡片 */}
      <StatsCards userTotal={userTotal} />

      {/* 第二块：邀请奖励卡片 */}
      <InvitationRewardCard
        rewardRules={rewardRules}
        onShare={handleShare}
        onQuestionClick={handleQuestionClick}
        code={code}
      />

      {/* 第三块：进度条展示 - 仅已登录时显示 */}
      {!!login && <InvitationBigProgress userList={userList} />}

      {/* 奖励规则弹窗 */}
      <RewardRulesModal
        visible={showRulesModal}
        onClose={handleCloseModal}
        rewardRules={rewardRules}
      />
    </div>
  );
};

export default InvitationRewardContent;
